import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  OnInit,
  OnDestroy,
} from '@angular/core';

@Directive({
  selector: '[smlIsVisible]',
})
export class VisibilityTrackerDirective implements OnInit, OnDestroy {
  private observer!: IntersectionObserver;

  @Output() visibilityChanged = new EventEmitter<boolean>();

  constructor(private el: ElementRef) {}

  ngOnInit() {
    const options = {
      root: null, // use the viewport as the root
      rootMargin: '0px', // margin around the root
      threshold: 0.5, // trigger when 50% of the element is visible
    };

    this.observer = new IntersectionObserver(
      this.handleIntersection.bind(this),
      options,
    );
    this.observer.observe(this.el.nativeElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }

  private handleIntersection(entries: IntersectionObserverEntry[]) {
    entries.forEach((entry) => {
      // Emit visibility status based on intersection ratio
      this.visibilityChanged.emit(entry.isIntersecting);
    });
  }
}
